var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnectionLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "46.8px",
    height: "46.8px",
    viewBox: "0 0 46.8 46.8",
    enableBackground: "new 0 0 46.8 46.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2CE37A",
    d: "M40.6,35l-1.7-4.7l0,0c1.8-5.3,1.5-11.3-1.6-16.6C31.8,4.2,19.6,0.9,10,6.5S-2.8,24.2,2.7,33.8 c5.5,9.6,17.8,12.8,27.3,7.3c2.1-1.2,3.8-2.7,5.3-4.5l4.8-0.8C40.5,35.7,40.7,35.4,40.6,35z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M30,28.7c1,0.5,1.2,0.2,0.6-0.7l-5.8-8.2c-0.6-0.9-1.9-1.1-2.8-0.5l-4.1,2.7c-0.9,0.6-2.4,0.6-3.3-0.1 l-5-3.7c-0.9-0.7-1.2-0.4-0.6,0.6l5.5,9.8c0.5,1,1.7,1.2,2.6,0.6l4.4-3c0.9-0.6,2.4-0.7,3.4-0.2L30,28.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnectionLogo);
export default __webpack_public_path__ + "static/media/enection-logo.92179645f089868633e278195eb24dfe.svg";
export { ForwardRef as ReactComponent };